import { AdminUserRole } from "@/modules/common/types/Users.enum";
import AneelTariffs from "@/modules/private/aneel-tariffs";
import Dashboard from "@/modules/private/dashboard";
import HelpHome from "@/modules/private/knowledge-base/pages/HelpHome";
import KnowledgeBaseEditor from "@/modules/private/knowledge-base/pages/KnowledgeBaseEditor";
import KnowledgeBaseList from "@/modules/private/knowledge-base/pages/KnowledgeBaseList";
import Leads from "@/modules/private/leads";
import LeadDetails from "@/modules/private/leads/pages/lead-details";
import LeadEdit from "@/modules/private/leads/pages/lead-edit";
import Logs from "@/modules/private/logs";
import LogsDetails from "@/modules/private/logs/pages/LogsDetails";
import Manager from "@/modules/private/manager";
import ManagerAdd from "@/modules/private/manager/pages/manager-add";
import ManagerDetails from "@/modules/private/manager/pages/manager-details";
import ManagerEdit from "@/modules/private/manager/pages/manager-edit";
import ManagerUserDetails from "@/modules/private/manager/pages/manager-user-details";
import ReleaseNoteEditor from "@/modules/private/release-notes/pages/ReleaseNoteEditor";
import ReleaseNoteList from "@/modules/private/release-notes/pages/ReleaseNoteList";
import Users from "@/modules/private/users";
import UserAdd from "@/modules/private/users/pages/user-add";
import UserDetails from "@/modules/private/users/pages/user-details";
import UserEdit from "@/modules/private/users/pages/user-edit";

import { ROUTES } from "../constants/routes";
import { IRoute } from "../routes";

const mainRouterList: IRoute[] = [
  {
    path: ROUTES.DASHBOARD.HOME,
    element: Dashboard,
  },
  {
    path: ROUTES.LOGS.LIST,
    element: Logs,
  },
  {
    path: ROUTES.LOGS.DETAILS,
    element: LogsDetails,
  },
  {
    path: ROUTES.MANAGER.LIST,
    element: Manager,
  },
  {
    path: ROUTES.MANAGER.DETAILS,
    element: ManagerDetails,
  },
  {
    path: ROUTES.MANAGER.MANAGER_USER_DETAILS,
    element: ManagerUserDetails,
  },
  {
    minimumRole: AdminUserRole.ADMIN,
    path: ROUTES.MANAGER.ADD,
    element: ManagerAdd,
  },
  {
    minimumRole: AdminUserRole.ADMIN,
    path: ROUTES.MANAGER.EDIT,
    element: ManagerEdit,
  },
  {
    path: ROUTES.USERS.LIST,
    element: Users,
  },
  {
    path: ROUTES.USERS.DETAILS,
    element: UserDetails,
  },
  {
    path: ROUTES.USERS.ADD,
    element: UserAdd,
    minimumRole: AdminUserRole.ADMIN,
  },
  {
    path: ROUTES.USERS.EDIT,
    element: UserEdit,
    minimumRole: AdminUserRole.ADMIN,
  },
  {
    path: ROUTES.ANEEL_TARIFFS.LIST,
    element: AneelTariffs,
  },
  {
    path: ROUTES.HELP.HOME,
    element: HelpHome,
  },
  {
    path: ROUTES.KNOWLEDGE_BASE.LIST,
    element: KnowledgeBaseList,
  },
  {
    path: ROUTES.KNOWLEDGE_BASE.ADD,
    element: KnowledgeBaseEditor,
    minimumRole: AdminUserRole.ADMIN,
  },
  {
    path: ROUTES.KNOWLEDGE_BASE.EDIT,
    element: KnowledgeBaseEditor,
  },
  {
    path: ROUTES.RELEASE_NOTES.LIST,
    element: ReleaseNoteList,
  },
  {
    path: ROUTES.RELEASE_NOTES.ADD,
    element: ReleaseNoteEditor,
    minimumRole: AdminUserRole.ADMIN,
  },
  {
    path: ROUTES.RELEASE_NOTES.EDIT,
    element: ReleaseNoteEditor,
  },
  {
    path: ROUTES.LEADS.LIST,
    element: Leads,
  },
  {
    path: ROUTES.LEADS.DETAILS,
    element: LeadDetails,
  },
  {
    path: ROUTES.LEADS.EDIT,
    element: LeadEdit,
    minimumRole: AdminUserRole.ADMIN,
  },
];

export default mainRouterList;
